const channels = [
  { name: "公众号", icon: "ri-wechat-2-line", handle: "九色黑料速递" },
  { name: "微博超话", icon: "ri-weibo-line", handle: "#九色黑料追踪#" },
  { name: "抖音话题", icon: "ri-arrow-up-line", handle: "九色黑料新进展" },
  { name: "Telegram", icon: "ri-telegram-line", handle: "jiuse_liaoliao" },
];

export default function DownloadEntry() {
  return (
    <section id="entry" className="bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="overflow-hidden rounded-2xl bg-foreground-950">
          <div className="grid grid-cols-1 gap-8 p-6 md:p-10 lg:grid-cols-2 lg:gap-12">
            {/* left copy */}
            <div className="flex flex-col justify-center gap-5">
              <div className="inline-flex w-fit items-center gap-2 rounded-full border border-background-800 bg-background-900 px-3 py-1">
                <i className="ri-wifi-line text-xs text-accent-400"></i>
                <span className="text-xs font-medium text-background-100">跨平台同步 · 刷新不丢进度</span>
              </div>
              <h2 className="font-display text-2xl font-black leading-snug text-background-50 md:text-3xl">
                把九色黑料<span className="text-accent-400">入口</span>
                <br />
                收进你的追更主页
              </h2>
              <p className="max-w-md text-sm leading-relaxed text-foreground-200">
                想看九色黑料爆料就用它聚合，想看九色黑料新进展就用它推送。无论是 App 还是关注渠道，
                刷新一下，九色黑料最新变化都不会漏。
              </p>
              <ul className="grid grid-cols-1 gap-3 text-sm text-foreground-200 sm:grid-cols-2">
                <li className="flex items-center gap-2">
                  <i className="ri-bell-line text-accent-400"></i>
                  新料即时推送
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-history-line text-accent-400"></i>
                  历史时间线全保留
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-shield-star-line text-accent-400"></i>
                  来源标注清晰
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-device-line text-accent-400"></i>
                  多端进度互通
                </li>
              </ul>
            </div>

            {/* right entry cards */}
            <div className="flex flex-col justify-center gap-3">
              <div className="flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  className="group flex flex-1 items-center justify-between gap-3 rounded-lg bg-background-50 p-4 text-left transition-colors hover:bg-accent-100"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                      <i className="ri-apple-line text-2xl"></i>
                    </span>
                    <span className="flex flex-col">
                      <span className="text-xs text-secondary-500">iOS 客户端</span>
                      <span className="text-sm font-bold text-foreground-950">从 App Store 获取</span>
                    </span>
                  </span>
                  <i className="ri-download-2-line text-lg text-primary-600 transition-transform group-hover:translate-y-0.5"></i>
                </button>
                <button
                  type="button"
                  className="group flex flex-1 items-center justify-between gap-3 rounded-lg bg-background-50 p-4 text-left transition-colors hover:bg-accent-100"
                >
                  <span className="flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                      <i className="ri-android-line text-2xl"></i>
                    </span>
                    <span className="flex flex-col">
                      <span className="text-xs text-secondary-500">Android 客户端</span>
                      <span className="text-sm font-bold text-foreground-950">扫码直接下载 APK</span>
                    </span>
                  </span>
                  <i className="ri-download-2-line text-lg text-primary-600 transition-transform group-hover:translate-y-0.5"></i>
                </button>
              </div>

              <div className="rounded-lg border border-background-800 bg-background-900 p-3">
                <p className="mb-2.5 flex items-center gap-2 px-1 text-xs font-semibold text-background-100">
                  <i className="ri-share-forward-line text-accent-400"></i>
                  关注这些渠道，动态不迷路
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {channels.map((c) => (
                    <button
                      key={c.name}
                      type="button"
                      className="flex items-center gap-2.5 rounded-md bg-foreground-950/40 px-3 py-2.5 text-left transition-colors hover:bg-foreground-950"
                    >
                      <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
                        <i className={`${c.icon} text-base`}></i>
                      </span>
                      <span className="flex min-w-0 flex-col">
                        <span className="text-xs font-semibold text-background-100">{c.name}</span>
                        <span className="truncate text-[11px] text-foreground-400">{c.handle}</span>
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}